import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RequestState from 'Enums/RequestState'
import StationActions from 'Stores/Station/Actions'
import ChargePointsList from '../ChargePointsList/ChargePointsList'
import Styles from './../ChargePointsContainer.module.css'
import OperatorAlertsSelectors from 'Stores/Alert/Selectors'

const AlertContainer = forwardRef(
  (
    {
      isEditing,
      fetchChargePointListRequestState,
      maxListHeight,
      scrollbarsHeight,
      alertChargePoints,
      displayedList = [],
      onSubmit,
    },
    ref,
  ) => {
    const chargePointListRef = useRef()

    const handleRefresh = () => {}

    const handleSubmit = (resetValues) => {
      const payload = chargePointListRef.current.handleSubmit(resetValues)
      return payload
    }

    const handleCancel = () => {
      chargePointListRef.current.handleCancel()
    }

    const didChange = () => {
      return chargePointListRef.current.didChange()
    }

    useImperativeHandle(ref, () => ({
      handleRefresh,
      handleSubmit,
      handleCancel,
      didChange,
    }))

    const isLoading = () => {
      return fetchChargePointListRequestState === RequestState.LOADING
    }

    return (
      <div
        className={Styles.ChargePointsList}
        style={{
          overflow: isEditing && !isLoading() ? 'unset' : 'hidden',
        }}
      >
        <ChargePointsList
          ref={chargePointListRef}
          displayedList={displayedList}
          dropdownList={alertChargePoints}
          isEditing={isEditing}
          isLoading={isLoading()}
          maxListHeight={maxListHeight}
          scrollbarsHeight={scrollbarsHeight}
          onSubmit={onSubmit}
        />
      </div>
    )
  },
)

function mapDispatchToProps(dispatch) {
  return {
    fetchStationList: (filter, offset, onNotFound) =>
      dispatch(StationActions.fetchStationList(filter, offset, onNotFound)),
  }
}

const mapStateToProps = (state) => ({
  alertChargePoints: OperatorAlertsSelectors.getAlertChargePoints(state),
})

AlertContainer.propTypes = {
  chargePoint: PropTypes.object,
  isEditing: PropTypes.bool,
  fetchChargePointListRequestState: PropTypes.string,
  maxListHeight: PropTypes.string,
  displayedList: PropTypes.arrayOf(PropTypes.object),
  dropdownList: PropTypes.arrayOf(PropTypes.object),
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AlertContainer)
